export interface InvasaoJuninaVideo {
  videoId:   string;
  titulo:    string;
  thumbnail: string;
}

export const INVASAO_JUNINA_VIDEOS: readonly InvasaoJuninaVideo[] = [
  {
    videoId:   'BjJPDWMUnLo',
    titulo:    'Eu Só Quero Um Xodó — Dominguinhos',
    thumbnail: 'https://i.ytimg.com/vi/BjJPDWMUnLo/hqdefault.jpg',
  },
  {
    videoId:   '23tMFbKkmaY',
    titulo:    'Sala de Reboco — Luiz Gonzaga',
    thumbnail: 'https://i.ytimg.com/vi/23tMFbKkmaY/hqdefault.jpg',
  },
  {
    videoId:   'K6qpVHE1JsE',
    titulo:    'Anunciação — Alceu Valença',
    thumbnail: 'https://i.ytimg.com/vi/K6qpVHE1JsE/hqdefault.jpg',
  },
  {
    videoId:   'fEFyTf5-vm0',
    titulo:    'Vem Morena — Luiz Gonzaga',
    thumbnail: 'https://i.ytimg.com/vi/fEFyTf5-vm0/hqdefault.jpg',
  },
  {
    videoId:   'DyFnn2c0b7Y',
    titulo:    'Morena Tropicana — Alceu Valença',
    thumbnail: 'https://i.ytimg.com/vi/DyFnn2c0b7Y/hqdefault.jpg',
  },
  {
    videoId:   'x5NiyIk9spc',
    titulo:    'Xote das Meninas — Luiz Gonzaga',
    thumbnail: 'https://i.ytimg.com/vi/x5NiyIk9spc/hqdefault.jpg',
  },
  {
    videoId:   'FQQgCXeuJuU',
    titulo:    'Pagode Russo — Luiz Gonzaga',
    thumbnail: 'https://i.ytimg.com/vi/FQQgCXeuJuU/hqdefault.jpg',
  },
  {
    videoId:   'JCmHj9Mj1vk',
    titulo:    'Meu Cenário — Zezo',
    thumbnail: 'https://i.ytimg.com/vi/JCmHj9Mj1vk/hqdefault.jpg',
  },
  {
    videoId:   '9gbWg7EGFEc',
    titulo:    'O Cheiro da Karolina — Luiz Gonzaga',
    thumbnail: 'https://i.ytimg.com/vi/9gbWg7EGFEc/hqdefault.jpg',
  },
  {
    videoId:   'mlpw-Wh58P8',
    titulo:    'Metamorfose Ambulante — Raul Seixas',
    thumbnail: 'https://i.ytimg.com/vi/mlpw-Wh58P8/hqdefault.jpg',
  },
  {
    videoId:   'WvAc6cIP_4k',
    titulo:    'Xote da Alegria — Falamansa',
    thumbnail: 'https://i.ytimg.com/vi/WvAc6cIP_4k/hqdefault.jpg',
  },
  {
    videoId:   'fZR1W8g7d3w',
    titulo:    'Asa Branca — Luiz Gonzaga',
    thumbnail: 'https://i.ytimg.com/vi/fZR1W8g7d3w/hqdefault.jpg',
  },
  {
    videoId:   'YH8bfyrgvvI',
    titulo:    'Xeem — Luiz Gonzaga',
    thumbnail: 'https://i.ytimg.com/vi/YH8bfyrgvvI/hqdefault.jpg',
  },
];

export function selecionarVideoInvasao(): InvasaoJuninaVideo {
  return INVASAO_JUNINA_VIDEOS[Math.floor(Math.random() * INVASAO_JUNINA_VIDEOS.length)];
}
